<template>
  <div class="c-contact-service">
    <template v-for="(item, index) in value.data">
      <img class="image" :key="index" :src="item.src" v-if="item.src" />
    </template>

    <ControlBox title="客服" v-if="showController">
      <c-upload
        :showCancelButton="false"
        @submit="handleSubmit"
      />
    </ControlBox>
  </div>
</template>

<script>
import { Vue, Component, Model, Prop } from 'vue-property-decorator';
import ControlBox from '../control-box';

@Component({
  components: {
    ControlBox
  }
})
export default class ContactService extends Vue {
  @Model('change', { type: Object, default: () => ({
    data: [
      {
        src: ''
      }
    ],
    config: {}
  }) }) value;
  @Prop(Boolean) showController;

  mounted() {
    this.syncChange();
  }

  syncChange() {
    this.$emit('change', this.value);
  }

  handleSubmit(data) {
    this.$set(this.value.data[0], 'src', data[0]);
    this.syncChange();
  }

}
</script>

<style lang="scss" scoped>
  .image {
    width: 100%;
    height: auto;
    object-fit: cover;
    vertical-align: top;
  }
</style>
